import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'universal_background_checks',
  inputShow: gql`
    query universalBackgroundChecks($input: UniversalBackgroundCheckQueryInput) {
      universalBackgroundChecks(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Universal Background Checks',
  },
};
